import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form, Radio } from 'antd'
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete } from "../../tool/axios"
import { SelectStores } from '../../component/common/Selects'
import { CheckImgs } from "../../component/common/Imgs"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 12 }
}

type fetchParams = {
    deal_store_id: string | undefined,
    refund_item: number | undefined,
    mix_refund_amount: number | undefined,
    max_refund_amount: number | undefined,
    review_status: undefined,
    date: any
    customer_name: string | undefined,
    contact_way: string | undefined,
    sales_name: string | undefined,
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        deal_store_id: undefined,
        refund_item: undefined,
        mix_refund_amount: undefined,
        max_refund_amount: undefined,
        review_status: undefined,
        sales_name: undefined,
        contact_way: undefined,
        customer_name: undefined,
        date: null
    }

    const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string } | undefined>()
    const [form] = Form.useForm()
    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [confrimMoneyVisible, setConfrimMoneyVisible] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    const [initDate, setInitDate] = useState<boolean>(true)

    const [data, setData] = useState<any>([])
    const [passType, setPassType] = useState<number | undefined>(undefined)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        if (initDate) {
            var startDate = moment().startOf('month');
            var endDate = moment().endOf('month');
            // 初始化退款日期
            fetchOtherParams.date = [startDate, endDate];

            setInitDate(false)
        }

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        if (params.date) {
            params.start_refund_date = params.date[0].format('YYYY-MM-DD')
            params.end_refund_date = params.date[1].format('YYYY-MM-DD')

            delete params.date
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        axiosTable.get('/finance_center/yuesao/refund_records/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
        })
    }

    const resetForm = () => {
        setInitDate(false)
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)

        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }
        if (params.date) {
            params.start_refund_date = params.date[0].format('YYYY-MM-DD')
            params.end_refund_date = params.date[1].format('YYYY-MM-DD')

            delete params.date
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        baseAxiosComplete('/finance_center/yuesao/refund_records/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const handlePassChange = (e: RadioChangeEvent) => {
        setPassType(e.target.value)
    }

    // 审核
    const onFinish = (value: any) => {
        baseAxiosComplete.post('/finance_center/yuesao/refund_records/review', {
            refund_id: activeRecord?.id,
            review_status: value.review_status,
            review_refuse_reason: value.review_refuse_reason

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams })
                setConfrimMoneyVisible(false)
            }
        })
    }

    return (<div className="common-page">
        {/* 财务中心 -> 财务管理 -> 月嫂退款管理 */}
        <BreadCrumb position={['财务中心', '月嫂退款管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores multiple showSearch placeholder="签单门店" value={fetchOtherParams.deal_store_id} onChange={(v: string[]) => { handleChange(v, 'deal_store_id') }} />
                </div>
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="联系方式" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_way') }} value={fetchOtherParams.contact_way} />

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["退款开始日期", "退款结束日期"]} value={fetchOtherParams.date} onChange={(v: any) => { handleChange(v, 'date') }} />
                <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="退款项目" value={fetchOtherParams.refund_item} onChange={(v: number) => { handleChange(v, 'refund_item') }}>
                    <Option value={1} key={1}>退单</Option>
                    <Option value={2} key={2}>提前出所</Option>
                    <Option value={3} key={3}>所内退款</Option>
                </Select>
                <div className="range-form-item fl" style={{ marginRight: 8, marginBottom: 12 }} >
                    <Input onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'mix_refund_amount') }} value={fetchOtherParams.mix_refund_amount} style={{ width: 130 }} placeholder="退款金额最小值" />
                    <span style={{ margin: '0 4px' }}>-</span>
                    <Input onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'max_refund_amount') }} value={fetchOtherParams.max_refund_amount} style={{ width: 130 }} placeholder="退款金额最大值" />
                </div>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="退款人" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'sales_name') }} value={fetchOtherParams.sales_name} />
                <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核结果" value={fetchOtherParams.review_status} onChange={(v: number) => { handleChange(v, 'review_status') }}>
                    <Option value={0} key={0}>待审核</Option>
                    <Option value={1} key={1}>审核通过</Option>
                    <Option value={2} key={2}>审核不通过</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="客户名称" dataIndex="customer_name" key="customer_name" />
                <Column title="联系方式" dataIndex="contact_way" key="contact_way" />
                <Column title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column title="退款日期" dataIndex="refund_date" key="refund_date" />
                <Column title="退款项目" dataIndex="refund_item" key="refund_item" />
                <Column title="退款金额" dataIndex="refund_amount" key="refund_amount" />
                <Column title="退款原因" dataIndex="refund_reason" key="refund_reason" width={520} render={
                    info => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = info.split('\n')
                        for (let j = 0; j < content_list.length; j++) {
                            if (j === 0) {
                                result = content_list[j];
                            } else {
                                result = <span>{result}{br}{content_list[j]}</span>;
                            }
                        }
                        return <div>{result}</div>;
                    }} />
                <Column title="退款凭证" dataIndex="refund_prov_pic_list" key="refund_prov_pic_list" render={(v: any) => {
                    return <Button onClick={() => {
                        setUrls(v)
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />
                <Column title="退款负责人" dataIndex="refund_sales_name" key="refund_sales_name" />
                <Column title="审核结果" dataIndex="review_status_desc" key="review_status_desc" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {record.review_status === 0 && permission.includes('审核') && <Button onClick={() => {
                                form.setFieldsValue({
                                    review_status: undefined,
                                    review_refuse_reason: undefined,
                                })

                                setPassType(undefined)
                                setConfrimMoneyVisible(true)
                                setActiveRecord({ id: record.refund_id })
                            }}>审核</Button>}
                        </Space>)
                    }}
                />
            </Table>
        </div>

        {/* 审核弹窗 */}
        <Modal title="退款审核" visible={confrimMoneyVisible} footer={false} onCancel={() => { setConfrimMoneyVisible(false) }}>
            <Form {...formItemLayout} form={form} onFinish={onFinish} >
                <Form.Item label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
                    <Radio.Group onChange={handlePassChange} value={passType}>
                        <Radio value={1}>通过</Radio>
                        <Radio value={2}>不通过</Radio>
                    </Radio.Group>
                </Form.Item>

                {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
                    <Input />
                </Form.Item>}

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />
    </div>)
}